import { loaderAction, setMasterFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { MASTER_FORM_INITIAL } from "../initialStateConstant";
import { GetServicesSettingsThunk } from "./GetServicesSettingsThunk";

export const UpdateMasterThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('master_id', args.master_id);
        formData.append('name', args.name);
        formData.append('specialization_id', args.specialization_id);
        formData.append('establishment', currentEstablishment);

        const response = await api({ data: formData, link: 'update_master' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму
            dispatch(setMasterFormAction(MASTER_FORM_INITIAL));
            // Запрашиваем обновлённые данные
            dispatch(GetServicesSettingsThunk());

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};